export const TagDic = {
    'activo': 'green',
    'inactivo': 'red',
    // 'activo': 'green',
}